<template>
  <div>
    <!-- <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div> -->
    <div class="profile-main-container bluebtn">
      <div class="d-flex align-items-center justify-content-center">
        <div class="profile-heading d-flex align-items-center mt-3 width-95">
          <img
            class="mr-2 pointer"
            src="../../assets/New-imgs/interviewProcess-icons/newInt-backBtn-arrow.svg"
            alt=""
            @click="$router.go(-1)"
          />
          <div class="ml-3">
            <span>Profile Setting</span>
          </div>
        </div>
      </div>

      <!-- tabs design  -->
      <div class="w-100 d-flex justify-content-center">
        <b-tabs class="profile-tabs" v-model="tabIndex">
          <!-- First level tabs -->
          <b-tab
            @click="navigate('personalData')"
            :active="activeTab == 'personalData'"
          >
            <template #title>
              <div class="d-flex align-items-center justify-content-center">
                Personal Data
              </div>
            </template>
          </b-tab>
          <!-- second level tabs-->
          <b-tab
            @click="navigate('basicAuthentication')"
            :active="activeTab == 'basicAuthentication'"
          >
            <template #title>
              <div class="d-flex align-items-center justify-content-center">
                Basic Authentication
              </div>
            </template>
          </b-tab>
          <!-- third level tabs-->
          <b-tab
            @click="navigate('deviceActivity')"
            :active="activeTab == 'deviceActivity'"
          >
            <template #title>
              <div class="d-flex align-items-center justify-content-center">
                Device Activity
              </div>
            </template>
          </b-tab>
          <!-- fourth level tabs-->
          <b-tab @click="navigate('query')" :active="activeTab == 'query'">
            <template #title>
              <div class="d-flex align-items-center justify-content-center">
                Raise a Query
              </div>
            </template>
          </b-tab>
        </b-tabs>
      </div>
      <div
        class="
          w-100
          d-flex
          align-items-center
          justify-content-center
          flex-column
          p-2
          profile-height-adjustment
        "
      >
        <div
          class="profile-sub-containers-height mt-2 pr-2"
          @scroll="handleScroll"
        >
          <div class="profile-sub-containers" id="personalData">
            <div v-if="showPersonalDataShimmer">
              <b-skeleton class="h-25 w-25"></b-skeleton>
            </div>
            <div class="profile-containers-head" v-else>Personal Data</div>
            <div>
              <b-row v-if="showPersonalDataShimmer">
                <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
              </b-row>
              <b-row v-else>
                <b-col>
                  <div class="d-flex align-items-center w-100 mt-4">
                    <div class="width-30 topDiv">
                      <label class="teams-label-font"
                        >User Name<span class="asterik">*</span></label
                      >
                    </div>
                    <div class="width-70 topDiv">
                      <b-form-input
                        class="teams-inputField"
                        type="text"
                        v-model="User.username"
                        autocomplete="firstName"
                        disabled
                      >
                      </b-form-input>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="d-flex align-items-center w-100 mt-4">
                    <div class="width-30 topDiv">
                      <label class="teams-label-font"
                        >First Name<span class="asterik">*</span></label
                      >
                    </div>
                    <div class="width-70 topDiv">
                      <b-form-input
                        :class="
                          $v.profileDetails.firstName.$error
                            ? 'teams-inputField-error'
                            : 'teams-inputField'
                        "
                        placeholder="Enter first name"
                        type="text"
                        v-model="$v.profileDetails.firstName.$model"
                        autocomplete="firstName"
                        :disabled="editProfile == false || saveProfile == true"
                        @keypress="alphabetsOnly"
                        @focusout="removeSpace('firstName')"
                      >
                      </b-form-input>
                      <div
                        class="
                          required-validation-fix
                          ml-1
                          basicAuth-validation-font
                          mt-1
                        "
                        v-if="
                          $v.profileDetails.firstName.$dirty &&
                          !$v.profileDetails.firstName.required
                        "
                      >
                        Required
                      </div>
                      <div
                        class="
                          required-validation-fix
                          ml-1
                          basicAuth-validation-font
                          mt-1
                        "
                        v-if="
                          $v.profileDetails.firstName.$dirty &&
                          !$v.profileDetails.firstName.maxLength
                        "
                      >
                        Exceeded the max char length of 38
                      </div>
                      <div
                        v-if="
                          editProfile &&
                          $v.profileDetails.firstName.$dirty &&
                          !$v.profileDetails.firstName.alphaNumeric
                        "
                        class="
                          required-validation-fix
                          ml-1
                          basicAuth-validation-font
                          mt-1mt-1
                        "
                      >
                        Invalid Name
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="showPersonalDataShimmer">
                <b-skeleton class="ml-3 mt-4 width-40 h-25"></b-skeleton>
              </b-row>

              <b-row v-else>
                <b-col>
                  <div class="d-flex align-items-center w-100 mt-4">
                    <div class="width-30 topDiv">
                      <label class="teams-label-font"
                        >Last Name<span class="asterik">*</span></label
                      >
                    </div>
                    <div class="width-70 topDiv">
                      <b-form-input
                        :class="
                          $v.profileDetails.lastName.$error
                            ? 'teams-inputField-error'
                            : 'teams-inputField'
                        "
                        placeholder="Enter last name"
                        type="text"
                        v-model="$v.profileDetails.lastName.$model"
                        autocomplete="lastname"
                        :disabled="editProfile == false || saveProfile == true"
                        @keypress="alphabetsOnly"
                        @focusout="removeSpace('lastName')"
                      >
                      </b-form-input>
                      <div
                        class="
                          required-validation-fix
                          ml-1
                          basicAuth-validation-font
                          mt-1
                        "
                        v-if="
                          editProfile &&
                          $v.profileDetails.lastName.$dirty &&
                          !$v.profileDetails.lastName.required
                        "
                      >
                        Required
                      </div>
                      <div
                        class="
                          required-validation-fix
                          ml-1
                          basicAuth-validation-font
                          mt-1
                        "
                        v-if="
                          !$v.profileDetails.lastName.maxLength &&
                          $v.profileDetails.lastName.required
                        "
                      >
                        Exceeded the max char length of 38
                      </div>
                      <div
                        v-if="
                          editProfile &&
                          $v.profileDetails.lastName.$dirty &&
                          !$v.profileDetails.lastName.alphaNumeric
                        "
                        class="
                          required-validation-fix
                          ml-1
                          basicAuth-validation-font
                          mt-1mt-1
                        "
                      >
                        Invalid Name
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="d-flex align-items-center w-100 mt-4">
                    <div class="width-30 topDiv">
                      <label class="teams-label-font"
                        >Email<span class="asterik">*</span></label
                      >
                    </div>
                    <div class="width-70 topDiv">
                      <b-form-input
                        v-model="profileDetails.email"
                        class="teams-inputField"
                        placeholder="Enter Email"
                        type="email"
                        disabled
                      >
                      </b-form-input>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div
              class="mt-4 d-flex align-items-center justify-content-end"
              v-if="editProfile == true"
            >
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <b-button
                    :disabled="profileLoader == true"
                    class="acs-cancelBtn-modal pointer mr-4"
                    @click="
                      (editProfile = false),
                        reassignPersonalDetails(),
                        $v.profileDetails.$reset()
                    "
                  >
                    Cancel
                  </b-button>

                  <div class="relativeclass">
                    <b-button
                      class="w-85px"
                      :class="
                        profileLoader
                          ? ' acs-addBtn-modal mp-loader-class defaultCursor'
                          : ' acs-addBtn-modal pointer'
                      "
                      @click="getProfile()"
                    >
                      <span v-if="!profileLoader">Save</span>
                    </b-button>
                    <div v-if="profileLoader" class="loader-pos">
                      <Loader />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mt-4 d-flex align-items-center justify-content-end"
              v-else-if="editProfile == false && !showPersonalDataShimmer"
            >
              <div class="d-flex align-items-center">
                <b-button
                  class="acs-addBtn-modal ml-3 pointer w-85px"
                  @click="editPersonalData()"
                >
                  Edit
                </b-button>
              </div>
            </div>
          </div>

          <div class="profile-sub-containers mt-2" id="basicAuth">
            <div
              :class="
                !showPersonalDataShimmer
                  ? 'd-flex align-items-center justify-content-between'
                  : ''
              "
            >
              <div v-if="showPersonalDataShimmer">
                <b-skeleton class="w-25 h-25"></b-skeleton>
              </div>
              <div class="profile-containers-head" v-else>
                Basic Authentication
              </div>
              <!-- <div class="d-flex align-items-center">
                <div class="createdOn-jds-font">Created on : &nbsp;</div>
                <div class="createdOn-jds-subfont">06-08-2022</div>
              </div> -->
            </div>
            <div v-if="showPersonalDataShimmer">
              <b-skeleton class="mt-4 w-85 h-25"></b-skeleton>
            </div>
            <div
              v-else-if="savedAuthentication && !showPersonalDataShimmer"
              class="d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center mt-4 width-48">
                <div class="width-30">
                  <label class="teams-label-font width-150px"
                    >Password<span class="asterik">&nbsp;*</span></label
                  >
                </div>
                <div class="position-relative width-70 topDiv">
                  <b-form-input
                    class="teams-inputField"
                    placeholder="********"
                    type="text"
                    disabled
                  >
                  </b-form-input>
                </div>
              </div>
              <div class="mt-5">
                <b-button
                  @click="resetpasswordfields(), (savedAuthentication = false)"
                  class="acs-addBtn-modal ml-3 pointer"
                >
                  Reset
                </b-button>
              </div>
            </div>
            <div v-else-if="!savedAuthentication && !showPersonalDataShimmer">
              <div class="d-flex align-items-center mt-4 w-50">
                <div class="width-30">
                  <label class="teams-label-font width-160px"
                    >Current Password<span class="asterik">*</span></label
                  >
                </div>
                <div class="ml-3 width-70 topDiv">
                  <b-form-input
                    :class="{
                      error:
                        $v.passwordDetails.currentPassword.$error ||
                        checkCurrentPsw,
                    }"
                    v-on:keyup.enter="resetPwd()"
                    v-model="passwordDetails.currentPassword"
                    class="password-inputField"
                    placeholder="Enter current password"
                    :type="showCurrentPassword ? 'text' : 'password'"
                    autocomplete="new-password"
                    @paste.prevent
                  >
                  </b-form-input>

                  <div
                    v-if="showCurrentPassword"
                    class="psw-set-noView-icon"
                    @click="togglePasswordVisibility('showCurrentPassword')"
                  >
                    <img
                      class="pointer"
                      src="../../assets/New Profile/view-icon.svg"
                      alt=""
                    />
                  </div>
                  <div
                    v-else
                    class="psw-set-noView-icon"
                    @click="togglePasswordVisibility('showCurrentPassword')"
                  >
                    <img
                      class="pointer"
                      src="../../assets/New Profile/not-view-icon.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="required-validation-fix basicAuth-validation-font"
                    v-if="
                      $v.passwordDetails.currentPassword.$dirty &&
                      !$v.passwordDetails.currentPassword.required
                    "
                  >
                    Required
                  </div>

                  <div
                    class="
                      required-validation-fix
                      ml-1
                      basicAuth-validation-font
                      mt-1
                    "
                    v-else-if="
                      $v.passwordDetails.currentPassword.$dirty &&
                      !$v.passwordDetails.currentPassword.maxLength
                    "
                  >
                    Exceeded the max char length of 55
                  </div>
                  <div
                    class="
                      required-validation-fix
                      ml-1
                      basicAuth-validation-font
                      mt-1
                    "
                    v-else-if="
                      passwordDetails.currentPassword != '' &&
                      checkCurrentPsw == true
                    "
                  >
                    Current password is incorrect
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center mt-4 w-50 relativeclass">
                <div class="width-30 topDiv">
                  <label class="teams-label-font width-160px"
                    >New Password<span class="asterik">*</span></label
                  >
                </div>
                <div class="ml-3 relativeclass topDiv width-70">
                  <b-form-input
                    :class="{
                      'password-inputField-new':
                        checkNewPsw == true &&
                        passwordDetails.newPswd != '' &&
                        hasUppercase &&
                        hasLowercase &&
                        hasNumber &&
                        hasSplcharacter,
                      'error-inputField':
                        $v.passwordDetails.newPswd.$error ||
                        (checkNewPsw == false && passwordDetails.newPswd != ''),
                    }"
                    class="password-inputField"
                    placeholder="Enter new password"
                    v-model="$v.passwordDetails.newPswd.$model"
                    @input="validatePassword"
                    :type="showNewPassword ? 'text' : 'password'"
                    :autocomplete="showNewPassword ? 'off' : 'new-password'"
                    @paste.prevent
                  >
                  </b-form-input>
                  <div
                    v-if="showNewPassword"
                    class="psw-set-noView-icon"
                    @click="togglePasswordVisibility('showNewPassword')"
                  >
                    <img
                      class="pointer"
                      src="../../assets/New Profile/view-icon.svg"
                      alt=""
                    />
                  </div>
                  <div
                    v-else
                    class="psw-set-noView-icon"
                    @click="togglePasswordVisibility('showNewPassword')"
                  >
                    <img
                      class="pointer"
                      src="../../assets/New Profile/not-view-icon.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="psw-set-noView-icon-2"
                    v-if="
                      checkNewPsw == true &&
                      passwordDetails.newPswd != '' &&
                      hasUppercase &&
                      hasLowercase &&
                      hasNumber &&
                      hasSplcharacter
                    "
                  >
                    <img src="../../assets/New Profile/match.svg" alt="" />
                  </div>
                  <div
                    v-else-if="
                      passwordDetails.newPswd != '' && checkNewPsw == false
                    "
                    class="psw-set-noView-icon-2"
                  >
                    <img src="../../assets/New Profile/no-match.svg" alt="" />
                  </div>
                </div>
                <div
                  v-if="passwordDetails.newPswd != '' && checkNewPsw == false"
                  class="adjust-uppercase newPass-validation-font ml-2"
                >
                  New Password cannot be same as current password
                </div>
                <div
                  v-else-if="
                    $v.passwordDetails.newPswd.$dirty &&
                    !$v.passwordDetails.newPswd.maxLength
                  "
                  class="adjust-uppercase newPass-validation-font ml-2"
                >
                  Exceeded the max char length of 55
                </div>

                <div
                  v-else
                  class="d-flex align-items-center adjust-uppercase w-100"
                >
                  <div>
                    <div class="d-flex align-items-center" v-if="hasUppercase">
                      <div>
                        <img
                          src="../../assets/New Profile/select-uppercase.svg"
                          alt=""
                        />
                      </div>
                      <div class="select-uppercase-font ml-2 mt-1">
                        1 Upper case
                      </div>
                    </div>
                    <div class="d-flex align-items-center" v-else>
                      <div>
                        <img
                          src="../../assets/New Profile/reject-uppercase.svg"
                          alt=""
                        />
                      </div>
                      <div class="reject-uppercase-font ml-2 mt-1">
                        1 Upper case
                      </div>
                    </div>
                  </div>

                  <!-- second -->
                  <div>
                    <div
                      class="d-flex align-items-center ml-2"
                      v-if="hasLowercase && passwordDetails.newPswd != ''"
                    >
                      <div>
                        <img
                          src="../../assets/New Profile/select-uppercase.svg"
                          alt=""
                        />
                        <!-- <img src="../../assets/New Profile/reject-uppercase.svg" alt="" /> -->
                      </div>
                      <div class="select-uppercase-font ml-2 mt-1">
                        <!-- for reject uppercase font ---- reject-uppercase-font -->
                        3 Lower case
                      </div>
                    </div>
                    <div class="d-flex align-items-center ml-2" v-else>
                      <div>
                        <img
                          src="../../assets/New Profile/reject-uppercase.svg"
                          alt=""
                        />
                      </div>
                      <div class="reject-uppercase-font ml-2 mt-1">
                        3 Lower case
                      </div>
                    </div>
                  </div>

                  <!-- third -->
                  <div>
                    <div
                      class="d-flex align-items-center ml-2"
                      v-if="hasSplcharacter"
                    >
                      <div>
                        <img
                          src="../../assets/New Profile/select-uppercase.svg"
                          alt=""
                        />
                        <!-- <img src="../../assets/New Profile/reject-uppercase.svg" alt="" /> -->
                      </div>
                      <div class="select-uppercase-font ml-2 mt-1">
                        <!-- for reject uppercase font ---- reject-uppercase-font -->
                        1 Special character
                      </div>
                    </div>
                    <div class="ml-2 d-flex align-items-center" v-else>
                      <div>
                        <img
                          src="../../assets/New Profile/reject-uppercase.svg"
                          alt=""
                        />
                      </div>
                      <div class="reject-uppercase-font ml-2 mt-1">
                        1 Special character
                      </div>
                    </div>
                  </div>

                  <!-- fourth -->
                  <div>
                    <div
                      class="d-flex align-items-center ml-2"
                      v-if="hasNumber"
                    >
                      <div>
                        <img
                          src="../../assets/New Profile/select-uppercase.svg"
                          alt=""
                        />
                        <!-- <img src="../../assets/New Profile/reject-uppercase.svg" alt="" /> -->
                      </div>
                      <div class="select-uppercase-font ml-2 mt-1">
                        <!-- for reject uppercase font ---- reject-uppercase-font -->
                        1 Number
                      </div>
                    </div>
                    <div class="ml-2 d-flex align-items-center" v-else>
                      <div>
                        <img
                          src="../../assets/New Profile/reject-uppercase.svg"
                          alt=""
                        />
                      </div>
                      <div class="reject-uppercase-font ml-2 mt-1">
                        1 Number
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center w-50 relativeclass mt-4">
                <div class="width-30 topDiv">
                  <label class="teams-label-font width-160px"
                    >Confirm Password<span class="asterik">*</span></label
                  >
                </div>

                <div class="ml-3 width-70 topDiv relativeclass">
                  <b-form-input
                    :class="
                      $v.passwordDetails.confirmPswd.$error ||
                      (passwordDetails.confirmPswd != '' &&
                        !passwordsMatch &&
                        passwordDetails.newPswd != '')
                        ? 'error-inputField'
                        : ''
                    "
                    class="password-inputField"
                    placeholder="Enter confirm password"
                    v-model="$v.passwordDetails.confirmPswd.$model"
                    type="password"
                    :autocomplete="showConfirmPassword ? 'off' : 'new-password'"
                    @paste.prevent
                  >
                  </b-form-input>
                  <div
                    class="psw-set-noView-icon"
                    v-if="
                      passwordsMatch &&
                      passwordDetails.confirmPswd != '' &&
                      passwordDetails.newPswd != '' &&
                      hasUppercase &&
                      hasLowercase &&
                      hasNumber &&
                      hasSplcharacter
                    "
                  >
                    <img src="../../assets/New Profile/match.svg" alt="" />
                  </div>
                  <div
                    class="psw-set-noView-icon"
                    v-else-if="
                      !passwordsMatch &&
                      passwordDetails.confirmPswd != '' &&
                      passwordDetails.newPswd != ''
                    "
                  >
                    <img src="../../assets/New Profile/no-match.svg" alt="" />
                  </div>
                  <div
                    v-if="
                      $v.passwordDetails.confirmPswd.$dirty &&
                      !$v.passwordDetails.confirmPswd.required
                    "
                    class="basicAuth-validation-font"
                  >
                    Required
                  </div>
                  <div
                    v-else-if="
                      $v.passwordDetails.confirmPswd.$dirty &&
                      !$v.passwordDetails.confirmPswd.maxLength
                    "
                    class="basicAuth-validation-font"
                  >
                    Exceeded the max char length of 55
                  </div>

                  <div
                    v-else-if="
                      !passwordsMatch &&
                      passwordDetails.confirmPswd != '' &&
                      passwordDetails.newPswd != ''
                    "
                    class="basicAuth-validation-font"
                  >
                    Password doesn't match
                  </div>
                </div>
              </div>

              <div
                class="mt-4 d-flex align-items-center justify-content-end"
                v-if="!savedAuthentication"
              >
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center">
                    <b-button
                      class="acs-cancelBtn-modal mr-4"
                      :disabled="pswLoader == true"
                      @click="
                        (resetPassword = false),
                          (savedAuthentication = true),
                          resetpasswordfields()
                      "
                    >
                      Cancel
                    </b-button>

                    <div class="relativeclass">
                      <b-button
                        class="w-85px"
                        :class="
                          pswLoader
                            ? 'acs-addBtn-modal mp-loader-class defaultCursor'
                            : 'acs-addBtn-modal pointer'
                        "
                        @click="resetPwd()"
                      >
                        <span v-if="!pswLoader">Save</span>
                      </b-button>
                      <div v-if="pswLoader" class="loader-pos">
                        <Loader />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="profile-sub-containers mt-2" id="deviceActivity">
            <div v-if="showPersonalDataShimmer || showDeviceActivityShimmer">
              <b-skeleton class="h-25 w-25"></b-skeleton>
            </div>
            <div class="profile-containers-head" v-else>Device Activity</div>

            <div
              class="mt-2"
              v-if="showPersonalDataShimmer || showDeviceActivityShimmer"
            >
              <div v-for="(i, index) in loopvar" :key="index">
                <div class="pro-padding">
                  <div class="d-flex align-items-center">
                    <div class="width-7">
                      <b-skeleton type="avatar"></b-skeleton>
                    </div>
                    <div class="width-93">
                      <b-row>
                        <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
                      </b-row>
                      <b-row>
                        <b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="mt-2" v-if="Object.keys(currentlyTrue).length != 0">
                <div class="currentlyActive-tag" v-if="currentlyTrue.current">
                  Currently Active
                </div>
                <div class="d-flex align-items-center">
                  <div class="width-7">
                    <img
                      src="../../assets/New Profile/google-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="width-93">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="device-activity-head mt-2">
                        {{ currentlyTrue.browser }}
                      </div>
                      <div
                        class="sign-out pointer"
                        @click="signOutConfirm(currentlyTrue)"
                      >
                        Sign Out
                      </div>
                    </div>
                    <div class="mt-2 w-100 d-flex">
                      <div class="width-40">
                        <div class="started-at">Started at</div>
                        <div class="device-activity-head">
                          {{ currentlyTrue.started }}
                        </div>
                      </div>

                      <div class="width-40">
                        <div class="started-at">Expires at</div>
                        <div class="device-activity-head">
                          {{ currentlyTrue.expires }}
                        </div>
                      </div>

                      <div class="width-20">
                        <div class="started-at">Last accessed on</div>
                        <div class="device-activity-head">
                          {{ currentlyTrue.lastAccess }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="profile-device-line"></div>
              </div>
              <hr v-if="allSessions.length >= 1" />
              <div class="mt-3">
                <div
                  class="device-activity-head"
                  v-if="allSessions.length >= 1"
                >
                  Other Devices
                </div>
                <div v-for="(i, index) in device" :key="index">
                  <div
                    v-for="(j, index2) in i.sessions"
                    :key="index2"
                    :class="i.sessions.length > 1 ? 'mt-3' : ''"
                  >
                    <div class="d-flex align-items-center" v-if="!j.current">
                      <div class="width-7">
                        <img
                          src="../../assets/New Profile/google-icon.svg"
                          alt=""
                        />
                      </div>
                      <div class="width-93">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                          "
                        >
                          <div class="device-activity-head mt-2">
                            {{ j.browser }}
                          </div>
                          <div
                            class="sign-out pointer"
                            @click="signOutConfirm(j)"
                          >
                            Sign Out
                          </div>
                        </div>
                        <div class="mt-2 w-100 d-flex">
                          <div class="width-40">
                            <div class="started-at">Started at</div>
                            <div class="device-activity-head">
                              {{ j.started }}
                            </div>
                          </div>

                          <div class="width-40">
                            <div class="started-at">Expires at</div>
                            <div class="device-activity-head">
                              {{ j.expires }}
                            </div>
                          </div>

                          <div class="width-20">
                            <div class="started-at">Last accessed on</div>
                            <div class="device-activity-head">
                              {{ j.lastAccess }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4 d-flex align-items-center justify-content-end">
                <div class="d-flex align-items-center">
                  <b-button
                    v-if="allSessions.length >= 1"
                    class="acs-addBtn-modal ml-3 pointer"
                    @click="$bvModal.show('signOutModal')"
                  >
                    Sign out all devices
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="profile-sub-containers mt-2"
            id="query"
            v-if="!ticketHistory && !ticketHistory.lenght"
          >
            <div v-if="showPersonalDataShimmer">
              <b-skeleton class="w-25 h-25"></b-skeleton>
            </div>
            <div class="profile-containers-head" v-else>Raise a Query</div>
            <div class="mt-1 w-100 text-center" v-if="!raiseQuery">
              <div v-if="showPersonalDataShimmer">
                <b-skeleton class="w-80 mt-4 h-25"></b-skeleton>
                <b-skeleton class="w-80 mt-4 h-25"></b-skeleton>
                <b-skeleton class="w-80 mt-4 h-25"></b-skeleton>
              </div>
              <div v-else>
                <img src="../../assets/New Profile/Query-img.svg" alt="" />
              </div>
              <div
                class="mt-3 d-flex justify-content-center w-100"
                v-if="!showPersonalDataShimmer"
              >
                <b-button
                  class="acs-addBtn-modal ml-3 pointer"
                  @click="showReportModal = true"
                >
                  Raise Query
                </b-button>
              </div>
            </div>
          </div>
          <div class="profile-sub-containers mt-2" id="query" v-else>
            <div class="d-flex justify-content-between align-items-center">
              <div class="profile-containers-head">Track Tickets</div>
              <b-button
                class="acs-addBtn-modal ml-3 pointer"
                @click="showReportModal = true"
                >Raise a query</b-button
              >
            </div>

            <div class="mt-2 started-at">Track & manage your tickets</div>
            <b-container class="profile-table-container mt-4">
              <b-row class="profile-header ml-0 mr-0 pb-2">
                <b-col cols="2">
                  Ticket ID
                  <img
                    class="ml-1"
                    src="../../assets/New Profile/blackDownArrow.svg"
                    alt=""
                  />
                </b-col>
                <b-col cols="2">
                  Category
                  <img
                    class="ml-1"
                    src="../../assets/New Profile/blackDownArrow.svg"
                    alt=""
                  />
                </b-col>
                <b-col cols="3">
                  Reason
                  <img
                    class="ml-1"
                    src="../../assets/New Profile/blackDownArrow.svg"
                    alt=""
                  />
                </b-col>
                <b-col cols="2">
                  Raised On
                  <img class="ml-1" alt="" />
                </b-col>
                <b-col cols="2">
                  Status
                  <img
                    class="ml-1"
                    src="../../assets/New Profile/blackDownArrow.svg"
                    alt=""
                  />
                </b-col>
                <b-col cols="1" class="pl-0">Action</b-col>
              </b-row>
              <div class="profile-table-overflow">
                <b-row
                  class="profile-blue-row"
                  v-for="(ticket, index) in ticketHistory"
                  :key="index"
                >
                  <b-col cols="2">{{ ticket.ticketID }}</b-col>
                  <b-col
                    cols="2"
                    :class="{
                      'text-reviews': ticket.module === '1',
                      'text-community': ticket.module === '2',
                      'text-interview': ticket.module === '3',
                      'text-platform': ticket.module === '5',
                      'text-course':
                        ticket.module !== '1' &&
                        ticket.module !== '2' &&
                        ticket.module !== '3',
                    }"
                    >{{
                      ticket.module === "1"
                        ? "Reviews"
                        : ticket.module === "2"
                        ? "Community"
                        : ticket.module === "3"
                        ? "Interview"
                        : ticket.module === "5"
                        ? "Platform"
                        : "Course"
                    }}</b-col
                  >
                  <b-col cols="3">{{ ticket.title }}</b-col>
                  <b-col cols="2">{{ formatDate(ticket.createdAt) }}</b-col>
                  <!-- <b-col cols="2" :class="ticket.status === '5' ? 'text-closed' : 'text-open'">Open</b-col> -->
                  <b-col cols="2" class="d-flex flex-column align-items-start">
                    <span
                      :class="
                        ticket.status === '5'
                          ? 'text-closed'
                          : ticket.status === '4'
                          ? 'text-appealed'
                          : 'text-open'
                      "
                    >
                      {{
                        ticket.status === "2"
                          ? "Processing"
                          : ticket.status === "3"
                          ? "Rejected"
                          : ticket.status === "4"
                          ? "Appeal"
                          : ticket.status === "5"
                          ? "Closed"
                          : "Open"
                      }}</span
                    >
                    <span
                      v-if="ticket.status === '5' && closedActivity(ticket)"
                      >{{ formatDate(closedActivity(ticket).activityAt) }}</span
                    >
                  </b-col>
                  <b-col cols="1" class="pl-0 pointer">
                    <img
                      @click="showTicketInfo(ticket)"
                      src="../../assets/New Profile/eye-icon.svg"
                      alt=""
                    />
                  </b-col>
                </b-row>
              </div>
            </b-container>
          </div>

          <!--  <div
            class="right-selected-container mt-3"
            v-if="showPreference && count > 1"
          >
            <div>
              <div
                @click="
                  (showPreference = !showPreference),
                    (showBasicAut = false),
                    (showProfInfo = false),
                    (showDevAct = false),
                    (showApp = false)
                "
                class="
                  pointer
                  right-heading-container
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <div class="right-selected-heading pl-0">
                  Preference Settings
                </div>
                <img
                  class="pointer"
                  src="../assets/mainProfile/up_arrow.svg"
                  alt=""
                />
              </div>
              <hr class="profile-hr" />
              <div class="profile-form-class">
                <span class="candash-head">
                  Logging in can be changed according to your preferences.
                </span>
                <div class="pref-setting mt-4">
                  <div class="js-head-txt">Apps</div>
                  <div class="d-flex mt-3 mb-4">
                    <div
                      v-if="accessAssessment"
                      class="d-flex flex-column align-items-center pref-cards"
                    >
                      <div>
                        <img src="../assets/mainProfile/profAsses.svg" alt="" />
                      </div>
                      <div class="mt-2">
                        <b-form-radio
                          v-model="selected"
                          value="assessment"
                          size="sm"
                          >Assessment</b-form-radio
                        >
                      </div>
                    </div>
                    <div
                      v-if="accessRecruitment"
                      class="d-flex flex-column align-items-center pref-cards"
                    >
                      <div>
                        <img src="../assets/mainProfile/profRec.svg" alt="" />
                      </div>
                      <div class="mt-2">
                        <b-form-radio
                          v-model="selected"
                          value="recruitment"
                          size="sm"
                          >Recruitment</b-form-radio
                        >
                      </div>
                    </div>
                    <div
                      v-if="accessTraining"
                      class="d-flex flex-column align-items-center pref-cards"
                    >
                      <div>
                        <img src="../assets/mainProfile/profTran.svg" alt="" />
                      </div>
                      <div class="mt-2">
                        <b-form-radio
                          v-model="selected"
                          value="training"
                          size="sm"
                          >Training</b-form-radio
                        >
                      </div>
                    </div>
                    <div
                      v-if="accessCandidate"
                      class="d-flex flex-column align-items-center pref-cards"
                    >
                      <div>
                        <img src="../assets/mainProfile/profCand.svg" alt="" />
                      </div>
                      <div class="mt-2">
                        <b-form-radio
                          v-model="selected"
                          value="candidate"
                          size="sm"
                          >Candidate</b-form-radio
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-end mt-5"
                  >
                    <div class="cancelbtntxt pointer mr-4">Cancel</div> 
                    <b-button class="addbtn px-4" @click="setPref()"
                      >Save</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="count > 1"
            class="
              right-unselected-container
              mt-3
              d-flex
              align-items-center
              justify-content-between
              pointer
            "
            @click="
              getPref(),
                (showPreference = !showPreference),
                (showDevAct = false),
                (showBasicAut = false),
                (showProfInfo = false),
                (showApp = false)
            "
          >
            <div>Preference Settings</div>
            <img
              class="pointer"
              src="../assets/mainProfile/down_arrow.svg"
              alt=""
            />
          </div> -->

          <!-- <div
            class="right-selected-container mt-3 pointer"
            v-if="showApp"
            @click="
              (showApp = !showApp),
                (showDevAct = false),
                (showBasicAut = false),
                (showProfInfo = false)
            "
          >
            <div
              class="
                right-heading-container
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div class="right-selected-heading">Applications</div>
              <img
                class="pointer"
                src="../assets/mainProfile/up_arrow.svg"
                alt=""
              />
            </div>
            <hr class="profile-hr" />
            <div class="profile-card-class">
              <div
                v-for="(i, index) in getApplication"
                :key="index"
                class="profile-card d-flex align-items-center mt-3"
              >
                <div class="d-flex align-items-center">
                  <img
                    src="../assets/mainProfile/google_chrome.svg"
                    alt="Google Chrome Icon"
                  />
                  <div
                    style="color: #000000"
                    class="profile-before-colon-text ml-2"
                  >
                    {{ i.clientId }}
                  </div>
                </div>
                <div class="d-flex ml-5">
                  <div class="profile-before-colon-text">
                    Application Type&nbsp;:
                  </div>
                  <div class="profile-after-colon-text">&nbsp;Internal</div>
                </div>
                <div class="d-flex ml-5" v-if="i.inUse == true">
                  <div class="profile-before-colon-text">Status &nbsp;:</div>
                  <div class="profile-after-colon-text">&nbsp;In Use</div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="
              right-unselected-container
              mt-3
              d-flex
              align-items-center
              justify-content-between
              pointer
            "
            @click="
              (showApp = !showApp),
                (showDevAct = false),
                (showBasicAut = false),
                (showProfInfo = false)
            "
          >
            <div>Applications</div>
            <img
              class="pointer"
              src="../assets/mainProfile/down_arrow.svg"
              alt=""
            />
          </div> -->
        </div>
      </div>
    </div>

    <b-modal
      v-model="showTicketInfoModal"
      id="ticketInfoModal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <header class="candash-modal-top p-3">
        <div class="fam-lato fw-500 fs-18 color-595959">
          Ticket ID : <span class="text-blue">{{ ticketInfo.ticketID }}</span>
        </div>
        <div class="d-flex justify-content-end pointer">
          <img
            @click="$bvModal.hide('ticketInfoModal')"
            class="rotate-on-hover"
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
          />
        </div>
      </header>
      <div class="tim-scroll mb-2">
        <div class="fam-mont fw-500 fs-13 text-3A3C40">Raised on</div>
        <div class="fam-mont fw-600 fs-14 text-3A3C40 mt-1">
          {{ formatDate(ticketInfo.createdAt) }}
        </div>
        <div class="fam-mont fw-500 fs-13 text-3A3C40 mt-3">Status</div>
        <div
          class="fam-mont fw-600 fs-14 text-00ae1c"
          :class="
            ticketInfo.status === '5'
              ? 'text-closed'
              : ticketInfo.status === '4'
              ? 'text-appealed'
              : 'text-open'
          "
        >
          {{
            ticketInfo.status === "2"
              ? "Processing"
              : ticketInfo.status === "3"
              ? "Rejected"
              : ticketInfo.status === "4"
              ? "Appeal"
              : ticketInfo.status === "5"
              ? "Closed"
              : "Open"
          }}
          <span
            class="text-3A3C40 fw-R"
            v-if="ticketInfo.status == '5' && closedActivity(ticketInfo)"
            >({{ formatDate(closedActivity(ticketInfo).activityAt) }})</span
          >
        </div>
        <div class="fam-mont fw-500 fs-13 text-3A3C40 mt-3">Category:</div>
        <div
          class="fam-mont fw-600 fs-14"
          :class="{
            'text-reviews': ticketInfo.module === '1',
            'text-community': ticketInfo.module === '2',
            'text-interview': ticketInfo.module === '3',
            'text-platform': ticketInfo.module === '5',
            'text-course':
              ticketInfo.module !== '1' &&
              ticketInfo.module !== '2' &&
              ticketInfo.module !== '3',
          }"
        >
          {{
            ticketInfo.module === "1"
              ? "Reviews"
              : ticketInfo.module === "2"
              ? "Community"
              : ticketInfo.module === "3"
              ? "Interview"
              : ticketInfo.module === "5"
              ? "Platform"
              : "Course"
          }}
        </div>
        <div class="fam-mont fw-500 fs-13 text-3A3C40 mt-3">Reason</div>
        <div class="fam-mont fw-600 fs-14 text-3A3C40 mt-1 text-break">
          {{ ticketInfo.title }}
        </div>
        <div class="fam-mont fw-500 fs-13 text-3A3C40 mt-3">Remark</div>
        <div class="fam-mont fw-600 fs-14 text-3A3C40 mt-1 text-break">
          {{ ticketInfo.remarks }}
        </div>

        <div
          class="closing-remarks mt-3 d-flex"
          v-if="closedActivity(ticketInfo) && ticketInfo.status == '5'"
        >
          <span class="stroke-line mr-3 mt-2"></span>Ticket Closing Remarks<span
            class="stroke-line ml-3 mt-2"
          ></span>
        </div>
        <div
          class="mt-3"
          v-if="closedActivity(ticketInfo) && ticketInfo.status == '5'"
        >
          <b-card
            no-body
            class="
              overflow-hidden
              w-100
              lb-right-card
              position-relative
              p-3
              admin-card
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="fw-500 fs-16 fam-lato">
                <img src="../../assets/New Profile/admin.svg" alt="" />
                <span class="admin ml-2">Super Admin:</span>
              </div>
              <span>{{
                formatDate(closedActivity(ticketInfo).activityAt)
              }}</span>
            </div>
            <hr class="my-2" style="border-top: 1px solid #888888" />
            <!-- title -->
            <div class="remark-title mt-2">Reason:</div>
            <div class="title-desc">
              {{ closedActivity(ticketInfo).title }}
            </div>

            <div class="remark-title mt-2">Remark:</div>
            <div class="remark-desc">
              {{ closedActivity(ticketInfo).remarks }}
            </div>
          </b-card>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="submitQuery"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$bvModal.hide('submitQuery')"
    >
      <div class="d-flex align-items-center justify-content-between w-100">
        <div class="d-flex align-items-center w-100">
          <div class="mb-5">
            <img src="../../assets/New Profile/submitted-icon.svg" alt="" />
          </div>
          <div class="ml-3 w-100">
            <div class="d-flex justify-content-between">
              <div class="teams-modal-head">Successfully Submitted!</div>
              <div
                @click="$bvModal.hide('submitQuery')"
                class="d-flex align-items-center justify-content-end"
              >
                <img
                  src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
                  alt=""
                  class="pointer rotate-on-hover"
                />
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="mt-2 teams-delete-folder-font" style="width: 80%">
                Please Note Ticket No. for further reference.
              </div>
              <div
                class="mt-2 teams-delete-folder-font"
                style="width: 20%"
                v-if="linkCopied"
              >
                <img src="../../assets/New Profile/greyTick.svg" alt="" />

                copied
              </div>
            </div>

            <div
              class="
                mt-2
                submitQuey-ticketNo
                d-flex
                align-items-center
                justify-content-between
                w-100
              "
            >
              <div>{{ ticketId }}</div>
              <div>
                <img
                  class="pointer"
                  @click="copyTheLink(ticketId)"
                  src="../../assets/New Profile/copyBtn.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="acs-addBtn-modal pl-5 pr-5"
          @click="$bvModal.hide('submitQuery')"
          >Close</b-button
        >
      </div>
    </b-modal>
    <b-modal id="signedout" centered hide-footer hide-header @click="$bvModal.hide('signedout')">
      <div class="d-flex flex-column align-items-center p-2">
        <div>
          <img src="../../assets/New Profile/successBig.svg" alt="" />
        </div>
        <div class="teams-modal-head mt-3 text-center">
          You have been signed out of all<br />
          devices.
        </div>
        <div class="mt-1"></div>
        <div class="mt-4">
          <b-button class="acs-addBtn-modal" @click="$bvModal.hide('signedout')"
            >Okay</b-button
          >
        </div>
      </div>
    </b-modal>

    <b-modal
      id="signOutModal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="closeSignout()"
    >
      <div class="d-flex justify-content-between w-100">
        <div class="d-flex align-items-center">
          <img
            class="mr-2"
            src="../../assets/New Profile/sign-out-icon.svg"
            alt=""
          />
          <div class="teams-modal-head">
            Are you sure you want to sign out of
            {{ selectedDevice == null ? "all devices" : "this device" }}?
          </div>
        </div>
        <div>
          <img
            @click="!deviceLoader ? closeSignout() : ''"
            :style="deviceLoader ? 'opacity:50%' : ''"
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            :class="!deviceLoader ? 'pointer rotate-on-hover' : ''"
            class="mb-4"
          />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          :disabled="deviceLoader == true"
          class="acs-cancelBtn-modal pointer"
          @click="!deviceLoader ? closeSignout() : ''"
        >
          Cancel
        </b-button>

        <div class="relativeclass">
          <b-button
            class="acs-addBtn-modal ml-3"
            :class="
              deviceLoader ? 'loader-class-signout defaultCursor' : 'pointer'
            "
            @click="
              selectedDevice == null
                ? ((deviceSignOut = true), signOutAllDevices())
                : signOut(selectedDevice)
            "
          >
            <span v-if="!deviceLoader">Sign Out</span>
          </b-button>
          <div v-if="deviceLoader" class="loader-pos-signout">
            <Loader />
          </div>
        </div>
      </div>
    </b-modal>
    <ReportModal
      v-if="showReportModal"
      :showModal="showReportModal"
      :referenceType="'11'"
      :referenceID="User.userID"
      @close-modal="showReportModal = false"
      @report-success="getTicketHistory"
    />
  </div>
</template>

<script>
import accountSettingsMixins from "../AccountSettings/accountSettingsMixins";
export default {
  name: "Profile",
  mixins: [accountSettingsMixins],

  created() {
    this.showPersonalDataShimmer = true;
    // Actions to execute when the component is created
    this.showProfInfo = true; // Set 'showProfInfo' to true by default
    this.savedAuthentication = true;

    // Fetching device activity, applications, and profile details
    this.getDeviceActivity();
    // this.getCookieData();
    this.getprofileDetails();
    this.getTicketHistory();
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll(event) {
      if (!this.allowScrollHandling) return;

      const scrollTop = event.target.scrollTop;
      const windowHeight = event.target.clientHeight;
      const scrollHeight = event.target.scrollHeight;
      const scrollPosition = scrollTop + windowHeight;

      const isAtBottom = scrollPosition >= scrollHeight - 30;
      if (isAtBottom) {
        this.activeTab = "query";
        return;
      }
      const scrollThreshold = scrollTop + 450;
      if (scrollTop === 0 && scrollThreshold === 450) {
        this.activeTab = "personalData";
        return;
      }

      const activeSection = this.sections.find((section) => {
        const el = document.getElementById(section);
        if (el) {
          const isInSection =
            el.offsetTop <= scrollThreshold &&
            el.offsetTop + el.offsetHeight > scrollThreshold;

          return isInSection;
        }
        return false;
      });
      if (activeSection) {
        // Map sections to corresponding tabs
        const sectionToTabMapping = {
          personalData: "personalData",
          basicAuth: "basicAuthentication",
          deviceActivity: "deviceActivity",
          query: "query",
        };
        this.activeTab = sectionToTabMapping[activeSection];
      }
    },
    navigate(name) {
      this.allowScrollHandling = false;
      let element = null;

      if (name === "personalData") {
        element = document.getElementById("personalData");
        this.activeTab = "personalData";
      } else if (name === "basicAuthentication") {
        element = document.getElementById("basicAuth");
        this.activeTab = "basicAuthentication";
      } else if (name === "deviceActivity") {
        element = document.getElementById("deviceActivity");
        this.activeTab = "deviceActivity";
      } else if (name === "query") {
        element = document.getElementById("query");
        this.activeTab = "query";
      }

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        setTimeout(() => {
          this.allowScrollHandling = true;
        }, 1000);
      }
    },

    // Methods to show/hide different sections of the profile
    showBasicAuth() {
      this.showBasicAut = true;
      this.showProfInfo = false;
      this.showDevAct = false;
      this.showApp = false;
      this.showPreference = false;
    },
    showProfile() {
      this.showProfInfo = true;
      this.showDevAct = false;
      this.showBasicAut = false;
      this.showApp = false;
      this.showPreference = false;
    },
    showDevice() {
      this.showDevAct = true;
      this.showBasicAut = false;
      this.showProfInfo = false;
      this.showApp = false;
      this.showPreference = false;
    },
    showApplication() {
      this.showApp = true;
      this.showDevAct = false;
      this.showBasicAut = false;
      this.showProfInfo = false;
      this.showPreference = false;
    },
    preferenceShow() {
      this.showDevAct = false;
      this.showBasicAut = false;
      this.showProfInfo = false;
      this.showApp = false;
      this.getPref();
      this.showPreference = true;
    },
  },
};
</script>

<style scoped>
.defaultCursor {
  cursor: default !important;
}
.profile-main-container {
  background: #e9ecef;
  color: #72738e;
  position: relative;
  height: calc(100vh - 70px);
  top: 70px;
  padding-left: 80px;
  overflow-x: hidden;
  padding-right: 15px;
}
.mp-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 84px;
}

.profile-heading {
  border-radius: 5px;
  background: rgba(32, 99, 155, 0.08);
  padding: 10px;
  color: #20639b;
  font-size: var(--size-18);
  font-weight: 600;
  font-family: "Lato", "sans-serif";
}

.profile-sub-containers {
  border-radius: 8px;
  border: 1px solid rgba(20, 20, 20, 0.05);
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.03);
  padding: 25px;
  width: 100%;
}
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}

.profile-height-adjustment {
  height: calc(100% - 110px);
}

.profile-sub-containers-height {
  width: 60%;
  height: 100%;
  overflow: auto;
}

.profile-containers-head {
  color: #000;
  font-size: 16px;
  font-weight: 600;
  font-family: "Montserrat", "sans-serif";
}

.candash-modal-top {
  border-bottom: 1px solid #e4e7ec;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.fam-lato {
  font-family: "lato", sans-serif;
}
.color-595959 {
  color: #595959 !important;
}
.text-blue {
  color: #20639b !important;
}
.fam-mont {
  font-family: "Montserrat", sans-serif;
}
.text-3A3C40 {
  color: #3a3c40 !important;
}
.tim-scroll {
  padding: 15px 20px;
  height: calc(100vh - 500px);
  max-height: 500px;
  overflow: auto;
}
.stroke-line {
  flex: 1;
  height: 1px;
  background-color: #ccc;
  display: block;
}
.closing-remarks {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 13px;
  color: #3a3c40;
}
.admin-card {
  border-radius: 10px;
  padding: 16px;
  background-color: #f9fcfd !important;
}

.remark-title {
  font: "Montserrat";
  font-weight: 400;
  font-size: 13px;
  color: #696969;
}

.title-desc {
  font-family: "Lato";
  font-weight: 400;
  font-size: 13px;
  color: #333333;
}

.remark-desc {
  font-family: "Lato";
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #333333;
}
.createdOn-jds-font {
  color: #3a3c40;
  font-size: var(--size-13);
  font-weight: var(--weight-LM);
}

.createdOn-jds-subfont {
  color: #3a3c40;
  font-size: var(--size-14);
  font-weight: var(--weight-M);
}

.currentlyActive-tag {
  border-radius: 4px 20px 20px 0px;
  background: #ffb200;
  color: var(--White, #fff);
  font-size: 10px;
  font-weight: 500;
  padding: 4px 7px;
  width: fit-content;
  font-family: "Montserrat", "sans-serif";
}

.device-activity-head {
  color: #3a3c40;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat", "sans-serif";
}
.profile-loader {
  width: fit-content !important;
  height: fit-content !important;
  margin: 0px auto !important;
  position: relative !important;
  top: -55px !important;
  right: -6px !important;
}

.loader-class-signout {
  opacity: 0.5;
  height: 28px;
  width: 89px;
}
.sign-out {
  color: #20639b;
  font-size: 13px;
  font-weight: 600;
  font-family: "Montserrat", "sans-serif";
}

.started-at {
  color: #7a7a7a;
  font-size: 13px;
  font-weight: 500;
  font-family: "Montserrat";
}
.validation-started-at {
  color: #eb0002;
  font-size: 10px;
  font-weight: 500;
}

.visibility-line {
  border-bottom: 1px solid #8c8c8c;
  padding-bottom: 15px;
  opacity: 0.35;
}

.delDetails-head {
  color: #263238;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat";
}

.required-font {
  color: #eb0002;
  font-size: 14px;
  font-weight: 500;
}

.error-inputField {
  border: 1px solid red;
}

.validation-font {
  color: #eb0002;
  font-size: 10px;
  font-weight: 500;
  position: absolute;
  left: 32%;
}

.basicAuth-validation-font {
  color: #eb0002;
  font-size: 10px;
  font-weight: 500;
  position: absolute;
  left: 1%;
}

.newPass-validation-font {
  color: #eb0002;
  font-size: 10px;
  font-weight: 500;
}
.loader-pos-signout {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 16px;
}

.adjust-uppercase {
  position: absolute;
  top: 38px;
  left: 34%;
}

.select-uppercase-font {
  color: #0f6b00;
  font-size: 10px;
  font-weight: 500;
  font-family: "Montserrat";
}

.reject-uppercase-font {
  color: #8c8c8c;
  font-size: 10px;
  font-weight: 500;
  font-family: "Montserrat";
}

.width-130px {
  width: 130px;
}

.width-150px {
  width: 150px;
}

.width-160px {
  width: 160px;
}

.width-7 {
  width: 7%;
}

.width-15 {
  width: 15%;
}

.width-20 {
  width: 20%;
}
.width-25 {
  width: 25%;
}
.h-25 {
  height: 25%;
}
.width-23 {
  width: 23%;
}
.width-30 {
  width: 30%;
}
.width-35 {
  width: 35%;
}

.width-40 {
  width: 40%;
}

.width-48 {
  width: 48%;
}
.width-50 {
  width: 50%;
}
.width-60 {
  width: 60%;
}
.width-65 {
  width: 65%;
}
.width-70 {
  width: 70%;
}
.width-73 {
  width: 73%;
}
.width-75 {
  width: 75%;
}

.width-80 {
  width: 80%;
}

.width-85 {
  width: 85%;
}

.width-93 {
  width: 93%;
}

.width-95 {
  width: 95%;
}

.copied-link {
  color: var(--cv-gray);
  font-size: 12px;
  font-weight: 400;
  font-family: "Lato", sans-serif;
}
@media screen and (max-width: 1745px) {
  .profile-sub-containers-height {
    width: 80%;
  }
}

.disable-modal-subfont {
  color: #344054;
  font-size: 13px;
  font-weight: 500;
}

.delete-account-line {
  border-bottom: 1px solid #8c8c8c;
  padding-bottom: 15px;
  margin-left: -7px;
}

.set-noView-icon {
  position: absolute;
  right: 3%;
  top: 6px;
}
.validation-text {
  position: relative;
  left: 10px;
}

.margin-top-class {
  margin-top: 35px;
}

.created-on-font {
  color: #3a3c40;
  font-size: 13px;
  font-weight: 600;
  font-family: "Montserrat", "sans-serif";
}
.psw-set-noView-icon-2 {
  position: absolute;
  right: 37px;
  top: 7px;
}
.psw-set-noView-icon {
  position: absolute;
  right: 4%;
  top: 7px;
}

.inputPlaceholder input::placeholder {
  font-weight: 400;
  font-size: 14px;
  color: #667085;
  font-family: "Montserrat", "sans-serif";
}

.validation-margin-top {
  margin-top: 47px;
}

.verfify-font-head {
  font-weight: 600;
  font-size: 14px;
  color: #344054;
  font-family: "Montserrat", "sans-serif";
}

.verfify-font-subhead {
  font-weight: 500;
  font-size: 12px;
  color: #344054;
  font-family: "Montserrat", "sans-serif";
}

.submitQuey-ticketNo {
  background: #e8eff4;
  padding: 4px 7px;
  font-family: "Montserrat", "sans-serif";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #20639b;
}

.w-85 {
  width: 85%;
}
.required-validation-fix {
  position: absolute;
  top: 40px;
  left: 4px;
}

.w-85px {
  width: 85px;
}

.text-community {
  color: #904ee2;
}
.text-reviews {
  color: #006cde;
}
.text-course {
  color: #f28b2b;
}
.text-interview {
  color: #68b15c;
}
.text-platform {
  color: #20639b;
}

.text-open {
  color: #ad1927;
}

.text-closed {
  color: #00ae1c;
}

.text-appealed {
  color: #f47529;
}

.profile-table-container .profile-header {
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #696969;
  padding-left: 30px;
}

.profile-table-container .profile-blue-row {
  background-color: #20639b0a;
  border-radius: 10px;
  padding: 14px 0;
  margin: 8px 0;
  display: flex;
  width: 100%;
  padding-left: 30px;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #2c2c2c;
}

.profile-table-container .col-2 {
  padding-left: 0px;
  display: flex;
  align-items: center;
}

.profile-table-container .col-3 {
  padding-left: 0px;
  display: flex;
  align-items: center;
}

.profile-table-container .col-1 {
  padding-left: 0px;
  display: flex;
  align-items: center;
}

.profile-table-overflow {
  min-height: auto;
  max-height: 325px;
  overflow: auto;
}
.fam-lato {
  font-family: "lato", sans-serif;
}
.color-595959 {
  color: #595959 !important;
}
.text-blue {
  color: #20639b !important;
}
.fam-mont {
  font-family: "Montserrat", sans-serif;
}
.text-3A3C40 {
  color: #3a3c40 !important;
}
</style>
